









































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from 'vuex-class'
import SFKnob from '@/components/SFKnob.vue';
import {ProgressFooter, SFPreloader} from '@/components';

import t from '@/i18n/translations';

import report from '@/api/report';


const reportNamespace = 'reports';
const progressNamespace = 'progress';

@Component({
    components: {
        SFKnob,
        ProgressFooter,
        SFPreloader
    },
})
export default class ReportSingle extends Vue {
    @Action('fetchReport', { namespace: reportNamespace }) fetchReport: any;
    @Getter('getReport', {  namespace: reportNamespace }) getReport: any;
    @Getter('getIsVisible', {  namespace: progressNamespace }) getIsVisible: any;
    // @Getter('getLLV', {  namespace: reportNamespace }) getLLV: any;
    @Mutation('toggleProgress', { namespace: progressNamespace }) toggleProgress: any;
    @Action('hide', { namespace: progressNamespace }) hide: any;
    @Getter('getProgressStatus', { namespace: progressNamespace }) getProgressStatus: any;

    selectedBranchID: string = '';
    i18n = t['nl'];

    mounted(): void {
        this.fetchReport(this.$route.params.id);
        this.selectedBranchID = this.$route.params.id;
        this.toggleProgress('summary');
        this.hide();
    }

    onHandleDownload(e: any) {
        report.getReportGUID(this.$route.params.id).then((resp: any) => {
            report.getReportPDF(resp.data).then((response: any) => {
                const linkSource = `data:application/octet-stream;charset=utf-16le;base64,${response.data}`;
                const downloadLink = document.createElement("a");
                const date = new Date();
                const fileName = `${date.toISOString().slice(0,10)}-report.pdf`;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
        })
    }
}
